/**
 * @author       justin.jeong@zumper.com (Justin Jeong)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  warn if user is offline
 */

import {
  selectIsOnline,
  selectWarnOffline,
  setWarnOffline,
  ButterAction,
} from '@zcode-ui/web-zumper-global-state'

const MESSAGE_DEFAULT =
  "Seems like you're having connectivity issues. We'll let you know when you're back online."

/**
 * @param {object} [params]
 * @param {boolean} [params.repeat]
 * @param {string} [params.message]
 * @returns
 */

const warnOffline = (params) => (dispatch, getState) => {
  const state = getState()
  const isOnline = selectIsOnline(state)
  const isWarned = selectWarnOffline(state)
  const shouldWarn = (params && params.repeat) || (!isOnline && !isWarned)
  if (!isOnline && !isWarned) {
    dispatch(setWarnOffline(true))
  }
  if (shouldWarn) {
    dispatch(
      ButterAction.addWarningButterBar({
        message: (params && params.message) || MESSAGE_DEFAULT,
      })
    )
  }
}

export default warnOffline
